import accountSetupIcon from '../assets/notify-complete-account-setup-icon.svg'
import defaultIcon from '../assets/notify-defult-icon.svg'
import newSurveyIcon from '../assets/notify-new-survey-available-icon.svg'
import profileUpdateIcon from '../assets/notify-profile-update-required-icon.svg'
import rewardIcon from '../assets/notify-reward-credited-icon.svg'
import surveyCompletedIcon from '../assets/notify-survey-completed-icon.svg'

export const notificationIconAssets = {
  newSurvey: newSurveyIcon,
  surveyCompleted: surveyCompletedIcon,
  reward: rewardIcon,
  profileUpdate: profileUpdateIcon,
  accountSetup: accountSetupIcon,
  default: defaultIcon,
} as const

/**
 * Maps notification title text to the design-system SVG asset (BFP-303 handoff).
 * Filenames under `assets/` mirror `User storis/temp notofi icons/`.
 */
export function resolveNotificationIconSrc(title: string): string {
  const normalized = title.trim().toLowerCase()

  if (
    normalized.includes('survey completed') ||
    normalized.includes('survey completion') ||
    normalized.includes('instrument submitted')
  ) {
    return notificationIconAssets.surveyCompleted
  }
  if (normalized.includes('new survey') || normalized.includes('survey available')) {
    return notificationIconAssets.newSurvey
  }
  if (
    normalized.includes('reward credited') ||
    normalized.includes('reward redeemed') ||
    normalized.includes('redeemed successfully') ||
    normalized.includes('gift card') ||
    normalized.includes('reward is ready')
  ) {
    return notificationIconAssets.reward
  }
  if (
    normalized.includes('demographic missing') ||
    normalized.includes('profile update') ||
    normalized.includes('demographic') ||
    normalized.includes('complete your profile')
  ) {
    return notificationIconAssets.profileUpdate
  }
  if (
    normalized.includes('account completion') ||
    normalized.includes('account setup') ||
    normalized.includes('complete your account')
  ) {
    return notificationIconAssets.accountSetup
  }
  if (
    normalized.includes('complete ekyc') ||
    normalized.includes('reward available to redeem') ||
    normalized.includes('ekyc failed') ||
    normalized.includes('ekyc under review')
  ) {
    return notificationIconAssets.reward
  }
  if (
    normalized.includes('mobile upselling') ||
    normalized.includes('mobile app') ||
    normalized.includes('get the brushfire') ||
    normalized.includes('download the app')
  ) {
    return notificationIconAssets.default
  }

  return notificationIconAssets.default
}
